import { useCallback, useEffect, useState } from "react";

export type Theme = "light" | "dark";

const STORAGE_KEY = "nexty-theme";

/**
 * Bascule clair/sombre.
 *
 * L'état initial est LU depuis le DOM et non recalculé : le script inline de
 * `index.html` a déjà posé la classe `.dark` avant le premier rendu, on se
 * contente de s'y synchroniser (sinon on repeindrait au montage).
 */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() =>
    document.documentElement.classList.contains("dark") ? "dark" : "light",
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggle };
}
